import React, { useContext, useMemo } from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { StorePodContext } from '../StorePod.context';

const getCurrentDateTimeAtStore = (store) => {
  const timeZone = store?.storeTimeZone;
  const fmt = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  const parts = Object.fromEntries(fmt.formatToParts(new Date()).map((part) => [part.type, part.value]));
  return new Date(
    `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`
  );
};

export const StorePodOpenAndClose = () => {
  let isOpen;
  const { store } = useContext(StorePodContext);
  const hours = store?.storeHours;
  const date = getCurrentDateTimeAtStore(store)
  const dayIndex = date.getDay();
  const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  const day = WEEKDAYS[dayIndex];
  const time = date.getHours();
  const openHour = parseFloat(hours?.[day]?.open);
  const closeHour = parseFloat(hours?.[day]?.close);

  const getNextDayOpen = useMemo(() => {
    const SATURDAY = 6;
    const MIDDAY = 12;
    let index;
    if (dayIndex === SATURDAY) {
      index = 0;
    } else {
      index = dayIndex + 1;
    }
    const nextDay = WEEKDAYS[index];
    const nextDaysHours = parseFloat(hours?.[nextDay]?.open.split(':')[0]);

    let meridian = '';
    if (nextDaysHours < MIDDAY) {
      meridian = 'AM';
    } else {
      meridian = 'PM';
    }
    return (
      `${hours?.[nextDay]?.open} ${meridian}`
    );
  });

  if ((time < openHour || time >= closeHour) || (openHour === closeHour)) {
    isOpen = false;
  } else {
    isOpen = true;
  }

  return (
    <div className="sui-flex" data-component="StorePodOpenAndClose">
      <Typography weight="bold" color={isOpen ? 'success' : 'danger'}>
        {isOpen ? 'Open' : 'Closed'}
      </Typography>&nbsp;
      <Typography color={isOpen ? 'success' : 'danger'}>
        {isOpen ? 'You\'re Currently Shopping:' : `Opens at ${getNextDayOpen}`}
      </Typography>
    </div>
  );
};

StorePodOpenAndClose.displayName = 'StorePodOpenAndClose';
